import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b0b9666"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-preview" }
const _hoisted_2 = { class: "report-preview__wrapper" }
const _hoisted_3 = { class: "report-preview__header" }
const _hoisted_4 = { class: "report-preview__clinic-information" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "report-preview__address" }
const _hoisted_7 = { class: "text-bold" }
const _hoisted_8 = { class: "text-bold" }
const _hoisted_9 = { class: "text-bold" }
const _hoisted_10 = { class: "text-bold" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "report-preview__title text-semi-bold" }, " Пародонтальный скрининг ", -1))
const _hoisted_12 = { class: "report-preview__information" }
const _hoisted_13 = { class: "report-preview__doctor" }
const _hoisted_14 = { class: "report-preview__text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Пациент:", -1))
const _hoisted_16 = { class: "report-preview__text" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Дата рождения:", -1))
const _hoisted_18 = { class: "report-preview__text" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Мед. карта:", -1))
const _hoisted_20 = { class: "report-preview__patient" }
const _hoisted_21 = { class: "report-preview__text" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Врач:", -1))
const _hoisted_23 = { class: "report-preview__text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Должность:", -1))
const _hoisted_25 = { class: "report-preview__text" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Дата обследования:", -1))
const _hoisted_27 = { class: "report-preview__indexes" }
const _hoisted_28 = { class: "report-preview__index" }
const _hoisted_29 = { class: "report-preview__index-block" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "report-preview__index-text" }, [
  /*#__PURE__*/_createTextVNode(" Модифицированный индекс "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" кровоточивости ")
], -1))
const _hoisted_31 = { class: "report-preview__value-block" }
const _hoisted_32 = { class: "report-preview__index-text" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "report-preview__index-grades" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "report-preview__text" }, "Здоровая десна: 0 - 9%"),
  /*#__PURE__*/_createElementVNode("li", { class: "report-preview__text" }, " Локализованный гингивит: 10-25% "),
  /*#__PURE__*/_createElementVNode("li", { class: "report-preview__text" }, " Генерализованный гингивит: > 25% ")
], -1))
const _hoisted_34 = { class: "report-preview__index" }
const _hoisted_35 = { class: "report-preview__index-block" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "report-preview__index-text" }, "CPITN / BPE", -1))
const _hoisted_37 = { class: "report-preview__value-block" }
const _hoisted_38 = { class: "report-preview__index-text" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "report-preview__index-grades" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "report-preview__text" }, "Здоровый: 0"),
  /*#__PURE__*/_createElementVNode("li", { class: "report-preview__text" }, "Гингивит: 1-2"),
  /*#__PURE__*/_createElementVNode("li", { class: "report-preview__text" }, "Пародонтит: 3-4, *")
], -1))
const _hoisted_40 = { class: "report-preview__recommendations" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "report-preview__subtitle" }, "Рекомендации", -1))
const _hoisted_42 = { class: "report-preview__recommendations--list" }
const _hoisted_43 = { class: "report-preview__recommendations--text report-preview__recommendations--date" }
const _hoisted_44 = { class: "report-preview__comments" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "report-preview__subtitle" }, "Комментарий врача", -1))
const _hoisted_46 = {
  key: 0,
  class: "report-preview__comments--list"
}
const _hoisted_47 = { class: "report-preview__row" }
const _hoisted_48 = { class: "report-preview__comment-doctor" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  span: 3,
  class: "text-bold"
}, "ФИО врача:", -1))
const _hoisted_50 = { span: 21 }
const _hoisted_51 = { class: "report-preview__comment-doctor" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  span: 3,
  class: "text-bold"
}, "Должность:", -1))
const _hoisted_53 = { span: 21 }
const _hoisted_54 = { class: "report-preview__file" }
const _hoisted_55 = {
  key: 1,
  class: "report-preview__text"
}

import { computed, onMounted, ref } from 'vue'
import { patientApi, userApi } from '@/shared/api'
import { DATE_FORMAT } from '@/shared/constants'
import { getDateFormat, showErrorMessage } from '@/shared/utils'
import { useRoute } from 'vue-router'
import { UserType } from '@/shared/types'
import WPreviewFooter from '@/widgets/WPreviewFooter/WPreviewFooter.vue'
import { ScreeningControllerInterface } from '../screeningController'

interface OrganizationInfo {
  logo: {
    id: string
  }
  name: string
  address: string
  site: string
  phone: string
}

interface Comment {
  id: number
  text: string
  files: []
  user_position: string
  user_name: string
}

interface Props {
  screeningController: ScreeningControllerInterface
  organization: OrganizationInfo
  userId: number | null
  comments: Comment[]
}

interface PatientInfo {
  surname: string
  name: string
  patronymic: string
  date: string
  cart_number: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    screeningController: null,
    organization: null,
    userId: null,
    comments: null
  },
  setup(__props: any) {

const props = __props as {
  screeningController: ScreeningControllerInterface
  organization: OrganizationInfo
  userId: number | null
  comments: Comment[]
}



const route = useRoute()
const patientId = computed(() => Number(route.params.patientId))
const userInfo = ref<UserType>()
const patientInfo = ref<PatientInfo>()

const getUserInfo = async () => {
  if (props.userId) {
    const [error, responseUser] = await userApi.getUser(props.userId)
    if (error) {
      showErrorMessage(error)
    } else {
      userInfo.value = responseUser.data.user
    }
  }
}

const getPatientInfo = async () => {
  const [error, responsePatient] = await patientApi.getPatientInfo(
    patientId.value
  )

  if (error) {
    showErrorMessage(error)
  } else {
    patientInfo.value = responsePatient.data.patient
  }
}

const logo = computed(() => {
  let domain = window.origin

  if (process.env.NODE_ENV === 'production') {
    domain = process.env.VUE_APP_BASE_URI
  }

  return props.organization?.logo.id
    ? `${domain}/api/web/admin/reports/storage/${props.organization?.logo.id}`
    : ''
})

onMounted(async () => {
  await getUserInfo()
  await getPatientInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "",
            class: "report-preview__logo"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(__props.organization?.name), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(__props.organization?.address), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(__props.organization?.site), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(__props.organization?.phone), 1)
          ])
        ]),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, [
            _hoisted_15,
            _createTextVNode(" " + _toDisplayString(`${patientInfo.value?.surname} ${patientInfo.value?.name} ${patientInfo.value?.patronymic}`), 1)
          ]),
          _createElementVNode("p", _hoisted_16, [
            _hoisted_17,
            _createTextVNode(" " + _toDisplayString(patientInfo.value?.date), 1)
          ]),
          _createElementVNode("p", _hoisted_18, [
            _hoisted_19,
            _createTextVNode(" " + _toDisplayString(patientInfo.value?.cart_number), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("p", _hoisted_21, [
            _hoisted_22,
            _createTextVNode(" " + _toDisplayString(userInfo.value?.name), 1)
          ]),
          _createElementVNode("p", _hoisted_23, [
            _hoisted_24,
            _createTextVNode(" " + _toDisplayString(userInfo.value?.position), 1)
          ]),
          _createElementVNode("p", _hoisted_25, [
            _hoisted_26,
            _createTextVNode(" " + _toDisplayString(_unref(getDateFormat)(
                new Date(__props.screeningController.dateAt),
                _unref(DATE_FORMAT).dmyDot
              )), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, _toDisplayString(__props.screeningController.modifiedBleedingIndexValue) + "% ", 1),
              _createElementVNode("div", {
                class: _normalizeClass([{
                  'report-preview__index--green':
                    __props.screeningController.modifiedBleedingIndexValue <= 9,
                  'report-preview__index--yellow':
                    __props.screeningController.modifiedBleedingIndexValue > 10 &&
                    __props.screeningController.modifiedBleedingIndexValue <= 25,
                  'report-preview__index--red':
                    __props.screeningController.modifiedBleedingIndexValue > 25,
                }, "report-preview__index-circle"])
              }, null, 2)
            ])
          ]),
          _hoisted_33
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, _toDisplayString(__props.screeningController.cpitnValue), 1),
              _createElementVNode("div", {
                class: _normalizeClass([{
                  'report-preview__index--green':
                    __props.screeningController.cpitnValue === '0',
                  'report-preview__index--yellow':
                    __props.screeningController.cpitnValue <= '2' &&
                    __props.screeningController.cpitnValue !== '0',
                  'report-preview__index--red':
                    __props.screeningController.cpitnValue > '2' ||
                    __props.screeningController.cpitnValue.includes('*'),
                }, "report-preview__index-circle"])
              }, null, 2)
            ])
          ]),
          _hoisted_39
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createElementVNode("ol", _hoisted_42, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.screeningController.recommendations, (recommendation, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "report-preview__text"
            }, _toDisplayString(recommendation), 1))
          }), 128))
        ]),
        _createElementVNode("p", _hoisted_43, " Дата следующего приема на профессиональную гигиену: " + _toDisplayString(_unref(getDateFormat)(
              new Date(__props.screeningController.reCleaningDate),
              _unref(DATE_FORMAT).dmyDot
            )), 1)
      ]),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        (__props.comments.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_46, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comments, (comment) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: comment.id,
                  class: "report-preview__text"
                }, [
                  _createTextVNode(_toDisplayString(comment.text) + " ", 1),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("span", _hoisted_50, _toDisplayString(comment.user_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("span", _hoisted_53, _toDisplayString(comment.user_position), 1)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      (comment.files && comment.files.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Document)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(`(${comment.files.length})`), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_55, "-"))
      ])
    ]),
    _createVNode(WPreviewFooter)
  ]))
}
}

})